export default __webpack_public_path__ + "static/media/two-eyes.29918a8d.yaml";